import React from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import './Dialog.css'
import { Button } from '@material-ui/core'

export default function FormDialog(props) {
    const open = props.open
    const openFunction = props.function
    const title = props.title
    return (
        <>
            <Dialog
                disableBackdropClick={props.disableBackDrop ? props.disableBackDrop : false}
                className={`${props.className} customDialog`}
                maxWidth={props.maxWidth ? props.maxWidth : 'sm'}
                open={open}
                onClose={openFunction}
                aria-labelledby="form-dialog-title"
            >
                <div className="cdTop">
                    <DialogTitle id="form-dialog-title">{title}</DialogTitle>
                    {props?.handleClose ? (
                        <Button
                            id="dialog_closeBtn"
                            className="closeBtn"
                            onClick={props?.handleClose}
                        >
                            <span className="material-icons">close</span>
                        </Button>
                    ) : null}
                </div>
                <DialogContent>{props.children}</DialogContent>
            </Dialog>
        </>
    )
}
